import React, { useState } from 'react';
import axios from 'axios';

const ForgotPasswordPage = ({ showNotification }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      showNotification && showNotification('Email is required', 'error');
      return;
    }
    try {
      setLoading(true);
      await axios.post('https://outiloeuvresvolees.inouiagency.com/api/auth/forgot-password', { email });
      setSent(true);
      showNotification && showNotification('Reset instructions sent (if account exists)', 'info');
    } catch (err) {
      showNotification && showNotification('Request failed', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Forgot Password</h1>
      {sent ? (
        <div className="text-sm text-gray-700">
          If an account exists for <span className="font-medium">{email}</span>, you will receive an email with password reset instructions.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="you@example.com"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full px-4 py-2 rounded-md text-white font-medium ${loading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          <div className="text-sm text-center">
            <a href="/login" className="text-blue-600 hover:text-blue-700">Back to login</a>
          </div>
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordPage;



